module.exports = __webpack_public_path__ + "img/landingPage.b25ebfa0.jpg";